/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleAssignment {
    getFixupPrototypeFunction() { return RoleAssignment.fixupPrototype; }

    static newInstance(model: Partial<RoleAssignment>): RoleAssignment {
        let obj = Object.assign(new RoleAssignment(), model);
        RoleAssignment.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleAssignment>): RoleAssignment {
        if (!model) return null;
        return RoleAssignment.newInstance(<RoleAssignment> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleAssignment) {
        if (!obj) return;

        models.RoleAssignment.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleAssignment): boolean {
        Object.setPrototypeOf(obj, RoleAssignment.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.roles) {
            for (let val of this.roles) {
                models.RoleAssignmentRole.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the tenant within the CoreStack account
     */
    tenant_name: string;

    /**
     * ID of the tenant within the CoreStack account
     */
    tenant_id: string;

    /**
     * List of roles for this tenant. User can have multiple roles within a tenant
     */
    roles: Array<models.RoleAssignmentRole>;

}
